import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { utils } from '@atlaskit/util-service-support';
var DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
export function fetchAgg(_x) {
  return _fetchAgg.apply(this, arguments);
}
function _fetchAgg() {
  _fetchAgg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var graphQuery, variables, operationName, _ref$aggAbsoluteUrl, url, headers, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          graphQuery = _ref.graphQuery, variables = _ref.variables, operationName = _ref.operationName, _ref$aggAbsoluteUrl = _ref.aggAbsoluteUrl, url = _ref$aggAbsoluteUrl === void 0 ? DEFAULT_GRAPHQL_ENDPOINT : _ref$aggAbsoluteUrl, headers = _ref.headers;
          options = {
            requestInit: {
              method: 'POST',
              headers: _objectSpread({
                'Content-Type': 'application/json'
              }, headers),
              body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
              })
            },
            queryParams: _objectSpread({}, operationName && {
              q: operationName
            })
          };
          return _context.abrupt("return", utils.requestService({
            url: url
          }, options));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchAgg.apply(this, arguments);
} // Marking all optional for safety